import React, { useContext, useState } from "react";
import { Button, Intent, Tooltip } from "@blueprintjs/core";
import copyToClipboard from "copy-to-clipboard";
import PageHeader from "../../components/page-header";
import { StoresContext, ApiContext } from "../_app";
import { StripeSessionResponse } from "../../api";
import Link from "next/link";

const ProfilePage = () => {
  const rootStore = useContext(StoresContext);
  const [revealed, setRevealed] = useState(false);
  if (!rootStore.userStore.isLoggedIn()) {
    return null;
  }
  const api = useContext(ApiContext);

  async function redirectToManageSubscription() {
    if (!rootStore.userStore.isLoggedIn()) {
      return;
    }

    const resp = await api.post<StripeSessionResponse>("/genome-portal-api/customer-portal", {});
    if (resp.error === undefined && resp.data !== undefined && resp.data !== null) {
      window.location.href = resp.data.redirect_url;
    }
  }

  const apiKey = rootStore.userStore.getApiKey();

  const manageSubscriptionBody = (
    <>
      <div className="profile-margin">
        <h3>Manage Subscription</h3>
        <p>
          Click the Manage Subscription button below to be redirected to Stripe to update your
          subscription:
        </p>
      </div>
      <div className="buttons">
        <Button
          onClick={() => redirectToManageSubscription()}
          text="Manage Subscription"
          className="profile-margin atcc--uppercase"
          intent={Intent.PRIMARY}
        />
        <Link href="/plans">
          <Button
            text="View plans"
            className="atcc--uppercase view-plans"
            intent={Intent.PRIMARY}
          />
        </Link>
      </div>
      <div className="profile-margin cancel-subscription">
        <p>
          Need to cancel or change your membership? Please{" "}
          <a href="mailto:support@onecodex.com">send us a note</a>.
        </p>
      </div>
    </>
  );

  const noSubscriptionBody = (
    <>
      <div className="profile-margin">
        <h3>Subscription Options</h3>
        <p>Interested in becoming a Supporting Member of ATCC? View membership options:</p>
      </div>
      <Link href="/plans">
        <Button
          text="View Plans"
          className="profile-margin atcc--uppercase"
          intent={Intent.PRIMARY}
        />
      </Link>
    </>
  );

  const masked = apiKey ? `${apiKey.slice(0, 4)}${"*".repeat(24)}${apiKey.slice(28, 32)}` : "";

  const apiKeyBody = (
    <>
      <div className="profile-margin">
        <h3>API Key</h3>
        <p>Click the key to reveal or hide it, or copy it directly:</p>
      </div>
      <div className="profile-margin profile-api-key">
        <Tooltip content={revealed ? "Click to hide" : "Click to reveal"}>
          <code onClick={() => setRevealed((r) => !r)} className="profile-api-key-toggle">
            {revealed ? apiKey : masked}
          </code>
        </Tooltip>
        <Button
          onClick={() => copyToClipboard(apiKey!, { format: "text/plain" })}
          text="Copy"
          small
        />
      </div>
    </>
  );

  return (
    <>
      <PageHeader name="Profile" />
      {rootStore.userStore.hasActiveSubscription() ? manageSubscriptionBody : noSubscriptionBody}
      <div className="profile-margin">
        <br></br>
        <br></br>
      </div>
      {apiKeyBody}
    </>
  );
};

export default ProfilePage;
